import styled from 'styled-components/macro';

export const DotsLoaderStyled = styled.div`
  position: relative;
  width: 10px;
  height: 10px;
  margin: 0 auto;
  border-radius: ${({ theme }): string => theme.radius.half};
  background-color: ${({ theme }): string => theme.colors.primary.variant1};
  color: ${({ theme }): string => theme.colors.primary.variant1};
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
  ${({ theme }): string => `
    ${theme.devices.tablet} {
      margin: 0 20px; 
    }
  `}

  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }

  &::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: ${({ theme }): string => theme.radius.half};
    background-color: ${({ theme }): string => theme.colors.primary.variant1};
    color: ${({ theme }): string => theme.colors.primary.variant1};
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 0s;
  }

  &::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: ${({ theme }): string => theme.radius.half};
    background-color: ${({ theme }): string => theme.colors.primary.variant1};
    color: ${({ theme }): string => theme.colors.primary.variant1};
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 1s;
  }

  @keyframes dotFlashing {
    0% {
      background-color: ${({ theme }): string => theme.colors.primary.variant1};
    }
    ${({ theme }): string => theme.radius.half},
    100% {
      background-color: ${({ theme }): string => theme.colors.primary.variant2};
    }
  }
`;
